import { hyperdbTriggers } from 'hyperdb-utils';
import * as config from '../../../../config';

const triggers = hyperdbTriggers({ config,
  namespace: 'EMAIL_TEMPLATE',
  entryPoint: '/email-templates',
  collectionName: 'email_templates',
  querySearchListing: [
    ['name', 'type'],
  ],
  successMessageCreate: 'Template created',
  successMessageUpdate: 'Template updated',
  successMessageDelete: 'Template deleted',
});

export default {
  ...triggers,
  getCorrespondingTemplate(dispatch, getState, { code, templateId }) {
    if (code) {
      let url = `/get-corresponding-template?code=${code}`;
      if (templateId) url += `&id=${templateId}`;
      return triggers.getData(dispatch, getState, { url });
    }
  }
};



// WEBPACK FOOTER //
// ./src/frontend/modules/email/template/triggers.js